import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Switch,
  Button,
  TextField,
  FormControlLabel
} from '@mui/material';
import { useThemeMode } from '../../StateManagement/themeContext';

const SettingsPage: React.FC = () => {
  const { mode, toggleTheme } = useThemeMode();

  const handleChangePassword = () => {
    // handle password change logic
  };

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Settings
      </Typography>

      <Grid container spacing={3}>
        {/* Profile Info */}
        {/* <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Profile Info
            </Typography>
            <TextField fullWidth label="First Name" margin="normal" defaultValue="Muhammed" />
            <TextField fullWidth label="Last Name" margin="normal" defaultValue="Shamal" />
            <TextField fullWidth label="Email" margin="normal" defaultValue="muhammed@example.com" disabled />
            <Button variant="contained" sx={{ mt: 2 }}>
              Update Profile
            </Button>
          </Paper>
        </Grid> */}

        {/* Theme Settings */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Appearance
            </Typography>
            <FormControlLabel
              control={<Switch checked={mode === 'dark'} onChange={toggleTheme} />}
              label="Dark Mode"
            />
          </Paper>
        </Grid>

        {/* Password Change */}
        {/* <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Change Password
            </Typography>
            <TextField fullWidth label="Current Password" type="password" margin="normal" />
            <TextField fullWidth label="New Password" type="password" margin="normal" />
            <TextField fullWidth label="Confirm New Password" type="password" margin="normal" />
            <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={handleChangePassword}>
              Update Password
            </Button>
          </Paper>
        </Grid> */}
      </Grid>
    </Box>
  );
};

export default SettingsPage;
